<template>
  <form-group :name="getname()" class="no-margin">
    <b-form-input
      :size="size"
      slot-scope="{ attrs, listeners }"
      v-bind="attrs"
      v-on="listeners"
      v-model="name"
      :readonly="readOnly"
      :name="getname()"
      @change="onChange"
      @input="onInput"
      @update="onUpdate"
      @blur="onBlur"
      :type="type"
      :placeholder="placeholder"
      v-on:keyup.enter="onEnter"
    />
  </form-group>
</template>

<script>
import VuelidateMixin from "@/mixins/VuelidateMixins";

export default {
  mixins: [VuelidateMixin],
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "sm",
    },
  },
  computed: {
    name: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    onEnter(){
      this.$emit('onEnter')
    },
    onChange(value) {
      this.$emit("change", value);
    },
    onInput(value) {
      this.$emit("input", value);
    },
    onUpdate(value) {
      this.$emit("update", value);
    },
    onBlur(event) {
      this.$emit("blur", event);
    },
  },
};
</script>

<style>
.invalid-feedback {
  text-align: left;
  color: #f93d5c;
  /* font-style: italic; */
}
.invalid-feedback:before {
  content: "\72";
  font-family: "ElegantIcons";
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  margin-right: 4px;
  margin-top: 4px;
}
.is-invalid input {
  border-color: #f93d5c;
}
</style>
